<div
    class="d-flex w-100 performance-grid-widget"
    [class.align-items-start]="_collapsed"
>
    <cmps-container
        class="cmps-scorecard-widget--cmps-container"
        [collapsable]="true"
        (collapsedChange)="_collapsed = $event; onTabChange(activeTab)"
        variant="colored"
    >
        <cmps-container-content class="cmps-container-content-grid">
            <cmps-wait-status
                [srStatus]="'Loading ' + _widget.name"
                *ngIf="_isLoadingData | async"
            ></cmps-wait-status>
            <div
                class="w-100 text-left"
                *ngIf="!(_isLoadingData | async)"
            >
                <cmps-performance-grid
                    [mode]="state?.mode"
                    [model]="state?.performanceGrid"
                    [messages]="state?.messages"
                    [messageAttributes]="state?.attributes"
                    [widget]="_widget"
                    (sortChange)="_onPerformanceSortChange($event)"
                    #performanceGrid
                    *ngIf="_page === 1"
                ></cmps-performance-grid>
                <cmps-team-grid
                    [model]="state?.teamGrid"
                    #teamGrid
                    *ngIf="_page === 2"
                ></cmps-team-grid>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
